import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-delete-dialog",
  templateUrl: "./delete-dialog.component.html",
  styleUrls: ["./delete-dialog.component.css"],
})
export class DeleteDialogComponent {
  @Input() title = "Confirmar exclusão";
  @Input() message = "Tem certeza que deseja excluir este item?";
  @Input() confirmLabel = "Deletar";
  @Input() cancelLabel = "Cancelar";

  @Output() delete = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onDelete(): void {
    this.delete.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
